"use strict";const s=require("./Tags.js");module.exports=s;
//# sourceMappingURL=index.js.map
